<template>
  <div>
    <div class="row" v-if="tabIndex == 0 || tabIndex == 2 || tabIndex == 1">
          <b-col cols="8" md="8" class="
                    d-flex
                    align-items-center
                    justify-content-start
                    mb-1
                    mt-1
                    ml-3
                  ">
            <b-breadcrumb :items="items" />
          </b-col>
          </div>
      <b-card no-body>
        <b-tabs v-model="tabIndex" nav-class="ml-3">
          <b-tab title="School Info" @click="checkSelectedTab(0)">
            <school-info v-if="tabIndex === 0" />
          </b-tab>

          <b-tab title="Grades" @click="checkSelectedTab(1)">
            <assign-grade v-if="tabIndex === 1" />
          </b-tab>

          <b-tab title="Users" @click="checkSelectedTab(2)">
            <school-app-users v-if="tabIndex === 2" />
          </b-tab>
        </b-tabs>
    </b-card>
  </div>
</template>


<script>
import {
    BCard,
    BRow,
    BCol,
    BFormInput,
    BButton,
    BTable,
    BMedia,
    BAvatar,
    BLink,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BTableSimple,
    BThead,
    BTr,
    BTh,
    BTd,
    BTbody,
    BTfoot,
    BFormCheckbox,
    BTab,
    BTabs,
  } from "bootstrap-vue";
  import vSelect from "vue-select";
  import Swal from "sweetalert2/dist/sweetalert2.js";
  import "sweetalert2/src/sweetalert2.scss";
  import { BBreadcrumb } from "bootstrap-vue";
  import axios from "axios";
  import Ripple from "vue-ripple-directive";
  import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
//   import LottieView from "./components/question/LottieView.vue";
  import DoLottieView from "@/views/components/question/DoLottieView.vue";
  import LottieView from "@/views/components/question/LottieView.vue";
//   import DoLottieView from "./components/question/DoLottieView.vue";
  import { v4 as uuidv4 } from 'uuid';



export default {
  components: {
    BCard,
    BTab,
    BTabs,
    BBreadcrumb,
    BCol,
    // Async Component from new path
    AssignGrade: () => import('@/views/AssignGrade.vue'),
    SchoolInfo: () => import('@/views/SchoolInfo.vue'),
    SchoolAppUsers: () => import('@/views/SchoolAppUsers.vue'),

  },

  data() {
    return {
      tabIndex: 0,
      items: [
      {
        text: JSON.parse(localStorage.getItem("schoolName")) || "School",
        to: {
          name: 'school-management',
          params: {
            schoolId: JSON.parse(localStorage.getItem("schoolid")),
          },
        },
      },
      {
        text: 'school',
        active: true,
      },
    ],
    }
  },

  created() {
    this.checkSelectedTab(0)
  },

  methods: {
    checkSelectedTab(index) {
      this.tabIndex = index
    },
  },
}
</script>
